// NOTE: price display in product detail page
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn, formatPrice } from '@/lib/utils'
import { Product } from '@/types/product'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type Props = {
  regularPrice: number
  comparePrice: number
  salePercent?: number
  isCoolClubSale?: boolean
  tags?: Record<string, string>
  product: Product
}

/**
 * Hiển thị giá sản phẩm chi tiết, ưu tiên giá campaign nếu đang active.
 * Nếu campaign đang active, lấy giá campaign (finalPrice), giá gốc (originalPrice), phần trăm giảm (discountPercent).
 * Nếu đang loading campaign, hiển thị skeleton.
 */
export const BestSellerProductPrice = ({
  regularPrice,
  comparePrice,
  salePercent,
  isCoolClubSale,
  tags,
  product,
}: Props) => {
  // Lấy danh sách tag sản phẩm
  const productTags = Array.isArray(tags) ? tags : Object.keys(tags || {})

  const t = useTranslations('product_detail.title')

  return (
    <div className='mt-2 flex items-end gap-2 lg:mt-5'>
      <div className='flex items-center gap-2 lg:gap-4'>
        {isCoolClubSale ? (
          <Image
            src={ImageHelper.getImageUrl('/image/December2024/mceclip0_21.png')}
            alt='Price'
            width={24}
            height={24}
            unoptimized
            className='h-6 w-6'
          />
        ) : null}
        <p
          className={cn(
            'font-criteria text-2xl font-semibold leading-none text-neutral-900 lg:text-4xl lg:leading-8',
            isCoolClubSale ? 'text-primary' : ''
          )}
        >
          {formatPrice(regularPrice)}
        </p>
      </div>
      {/* Hiển thị giá gạch ngang nếu có giảm giá */}
      {comparePrice && comparePrice !== regularPrice ? (
        <del className='font-criteria text-sm !leading-none text-neutral-400'>
          {formatPrice(comparePrice)}
        </del>
      ) : null}
    </div>
  )
}
